import { FCX } from 'react';
import styled from '@emotion/styled';
import { AnyImage } from 'src/components';

type Props = {
  filename: string;
  size: number;
};

const Component: FCX<Props> = ({ className, filename }) => (
  <div className={className}>
    <AnyImage filename={filename} />
  </div>
);

const StyledComponent = styled(Component)`
  width: ${({ size }) => size}em;
  height: ${({ size }) => size * 0.8}em;
  overflow: hidden;
  filter: drop-shadow(16px 0 var(--color-secondary-light));

  img {
    width: 100%;
  }
`;

export default StyledComponent;
